import { useTexts } from '../../hooks/useTexts'
import { form } from '../formState'

const MAXLENGTH = 250

export function TrafficDescription() {
  const { field } = form.useFormField('description')
  const texts = useTexts()

  return (
    <form.TextField
      label={texts.form.trafficDescription}
      validateOn="change"
      name="description"
      textfieldProps={{
        inputProps: {
          maxLength: MAXLENGTH,
        },
      }}
      helperText={`${field.value.length}/${MAXLENGTH}`}
      debounce={null}
    />
  )
}
